import { MatchmakingStrategy, MatchType, PlayerGrouping } from '@nova/types';

import { assetLobbyThumbZoneRush } from './asset-bundle-names';

const zr3v3GamePlayConfigBase = {
  matchDuration: 1000 * 60 * 5,
  pointsMax: 100,
  updatePointsInterval: 1000,
  minionSpawnRadius: 250,
  minionCapPerTeam: 15,
  minionCapPerObjective: 8,
  pointsPerTick: 0.5,
  pointsPerTickDominated: 1
} as const;

const zr3v3GamePlayConfigCoop = {
  ...structuredClone(zr3v3GamePlayConfigBase),
  minionSpawnEachLane: 1,
  minionSpawnGroupsEachWave: 3,
  minionSpawnGroupCooldown: 1400,
  minionWaveCooldown: 30000
} as const;

const zr3v3UiConfigsBase = {
  countDownTimes: 5,
  matchStartUiDelay: 3000,
  matchStartSoonUiDuration: 2000,
  countdownInterval: 1000,
  matchBeginDisplayDuration: 2000,
  playerDisconnectDisplayDuration: 5000,
  miniMap: {
    textureName: 'mini_map_3v3',
    bgFrame: 'map-base',
    gameMapDimensions: {
      width: 9510,
      height: 5788
    },
    entityZIndex: {
      dm_objective: 1,
      tower: 2,
      minion: 3,
      bot: 4
    }
  }
} as const;

export const mapConfigDominationLiteral = [
  {
    type: MatchType.zoneRush,
    id: 'cm_3v3_tutorial',
    assetName: 'domination-tutorial-map',
    name: 'loc:::map_config_zone_rush_tutorial_name',
    teamCount: 1,
    teamSize: 0,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    matchmakingConfig: {
      strategy: MatchmakingStrategy.IMMEDIATE_LOBBY_MATCH
    },
    gamePlayConfig: {
      ...structuredClone(zr3v3GamePlayConfigBase),
      minionSpawnEachWave: 0,
      minionWaveCooldown: 30000
    },
    uiConfigs: structuredClone(zr3v3UiConfigsBase),
    lobbyConfig: {
      title: 'loc:::map_config_tutorial',
      subtitle: 'loc:::solo',
      dataKey: assetLobbyThumbZoneRush
    }
  },
  {
    type: MatchType.zoneRush,
    // Persisted id. Preferred name: `cm_3v3_sp` (solo coop vs AI). Rename only with match-history DB migration.
    id: 'cm_3v3_coop',
    assetName: 'domination-map',
    name: 'loc:::game_list_zonerush_name',
    teamCount: 2,
    teamSize: 3,
    playerGrouping: PlayerGrouping.SP,
    isAvailable: true,
    afkTimer: 60000,
    matchmakingConfig: {
      strategy: MatchmakingStrategy.IMMEDIATE_LOBBY_MATCH
    },
    gamePlayConfig: structuredClone(zr3v3GamePlayConfigCoop),
    uiConfigs: structuredClone(zr3v3UiConfigsBase),
    lobbyConfig: {
      title: 'loc:::coopVsAi',
      subtitle: 'loc:::solo',
      dataKey: assetLobbyThumbZoneRush,
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  },
  {
    type: MatchType.zoneRush,
    // Preferred name: `cm_3v3_coop` (MP coop). Rename only with match-history DB migration if this id is ever persisted.
    id: 'cm_3v3_coop_mp',
    assetName: 'domination-map',
    name: 'loc:::game_list_zonerush_name',
    teamCount: 2,
    teamSize: 3,
    playerGrouping: PlayerGrouping.MP_COOP,
    isAvailable: false,
    afkTimer: 60000,
    matchmakingConfig: {
      strategy: MatchmakingStrategy.IMMEDIATE_LOBBY_MATCH
    },
    gamePlayConfig: structuredClone(zr3v3GamePlayConfigCoop),
    uiConfigs: structuredClone(zr3v3UiConfigsBase),
    lobbyConfig: {
      title: 'loc:::coopVsAi',
      subtitle: 'loc:::3v3',
      dataKey: assetLobbyThumbZoneRush,
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  },
  {
    type: MatchType.zoneRush,
    id: 'cm_3v3_pvp',
    assetName: 'domination-map',
    name: 'loc:::game_list_zonerush_name',
    teamCount: 2,
    teamSize: 3,
    playerGrouping: PlayerGrouping.MP_PVP,
    isAvailable: true,
    afkTimer: 60000,
    matchmakingConfig: {
      strategy: MatchmakingStrategy.QUEUED_TEAM_MATCH
    },
    gamePlayConfig: structuredClone(zr3v3GamePlayConfigCoop),
    uiConfigs: structuredClone(zr3v3UiConfigsBase),
    lobbyConfig: {
      title: 'loc:::pvp',
      subtitle: 'loc:::3v3',
      dataKey: assetLobbyThumbZoneRush,
      unlockTooltip: 'loc:::completeTutorialToUnlock'
    }
  }
] as const;
